import IntroComponent from './IntroComponent';

export default IntroComponent;
